import { AbstractApiRequest } from '@/communication/base/AbstractApiRequest.ts';

export class PaazlGetShippingOptionsRequest<
  T,
  D = Record<string, never>,
> extends AbstractApiRequest<T, D> {
  private shippingCutoffTime: string | undefined = undefined;
  private processingDays: number | undefined = undefined;
  private width: number = 0;
  private height: number = 0;
  private paazlDeliveryMatrix: string | undefined = undefined;
  private productPrice: number = 0;

  protected getEndPoint(): string {
    const params: Record<string, string | number | undefined> = {
      shipping_cutoff_time: this.shippingCutoffTime,
      processing_days: this.processingDays,
      width: this.width,
      height: this.height,
      paazl_delivery_matrix: this.paazlDeliveryMatrix,
      product_price: this.productPrice,
    };

    const queryString = Object.entries(params)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    return `${this.baseUrl}/canvascompany/paazl/product-page/shipping-options?${queryString}`;
  }

  public setShippingCutoffTime(shippingCutoffTime?: string): this {
    this.shippingCutoffTime = shippingCutoffTime;
    return this;
  }

  public setProcessingDays(processingDays?: number): this {
    this.processingDays = processingDays;
    return this;
  }

  public setWidth(width: number): this {
    this.width = width;
    return this;
  }

  public setHeight(height: number): this {
    this.height = height;
    return this;
  }

  public setPaazlDeliveryMatrix(paazlDeliveryMatrix?: string): this {
    this.paazlDeliveryMatrix = paazlDeliveryMatrix;
    return this;
  }

  public setProductPrice(productPrice: number): this {
    this.productPrice = productPrice;
    return this;
  }
}
